import Header from 'settings-ui-lib/components/Header';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import PortalIdParser from 'PortalIdParser';
import EmailAddressContainer from '../containers/EmailAddressContainer';
import Password from './Password';
import SecurityPhoneNumberContainer from '../containers/security/SecurityPhoneNumberContainer';
import TwoFactorAuthContainer from '../containers/TwoFactorAuthContainer';
import LogOutAllSessionsContainer from '../containers/LogOutAllSessionsContainer';
import SelfDeletionContainer from '../containers/SelfDeletionContainer';
import TwoFactorAuthLoginRequiredAlertContainer from '../containers/TwoFactorAuthLoginRequiredAlertContainer';
import UserImpersonationAlert from '../containers/UserImpersonationAlert';
import PasskeysContainer from '../containers/PasskeysContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Security = () => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(TwoFactorAuthLoginRequiredAlertContainer, {}), /*#__PURE__*/_jsx(Header, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.security"
      }),
      description: PortalIdParser.get() === undefined ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.securityDescription"
      }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link: UILink
        },
        options: {
          href: `/settings/${PortalIdParser.get()}/account-defaults/security`
        },
        message: "userPreferences.securityDescription_jsx"
      })
    }), /*#__PURE__*/_jsx(UserImpersonationAlert, {}), /*#__PURE__*/_jsx(EmailAddressContainer, {}), /*#__PURE__*/_jsx(Password, {}), /*#__PURE__*/_jsx(SecurityPhoneNumberContainer, {}), /*#__PURE__*/_jsx(PasskeysContainer, {
      isHubless: true
    }), /*#__PURE__*/_jsx(TwoFactorAuthContainer, {}), /*#__PURE__*/_jsx(LogOutAllSessionsContainer, {}), /*#__PURE__*/_jsx(SelfDeletionContainer, {})]
  });
};
export default Security;